<div class="main-wrapper">
  <div class="container">
    <div class="apostrophe">
      <div class="heading text-center">
        {{section?.header}}
      </div>
      <div class="sub-heading text-center">
        {{section?.sub_header}}
      </div>
    </div>
    <div class="card-wrapper">
      <ngx-glide [showArrows]="false" [showBullets]="false" [perView]="3" [gap]="10"
        [breakpoints]="breakpoints" [bound]="true">
        <div class="slide" *ngFor="let item of section?.data_images">
          <div class="cards">
            <div class="{{item?.profile}}"></div>
            <div class="designation">{{item?.title}}</div>
            <div class="description">{{item?.text}}</div>
            <!-- <a href="{{item?.blog}}" class="read-story text-center">Read their story</a> -->
            <div class="footer">
              Reach this campaigner:
              <div class="social-share">
                <a *ngIf="item.facebook" [href]="item.facebook" target="_blank"><span class="facebook-icon icon-props"></span></a>
                <a [href]="'https://api.whatsapp.com/send?phone='+item.phone" target="_blank"><span class="whatsapp-icon icon-props"></span></a>
                <span (click)="openPopup(contact, item.phone)" class="contact-link"><span class="phone-icon icon-props"></span></span>
              </div>
            </div>
          </div>
        </div>
      </ngx-glide>
    </div>
  </div>
</div>

<ng-template #contact>
    <div class="contact">
      <span class="material-icons">info</span>
       Contact Number: {{contactNum}}
       <button mat-raised-button class="got-it" (click)="dialog.closeAll()">Got it</button>
    </div>
</ng-template>